import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api.js';
import { toast } from '../../lib/toast.js';

interface Props {
  onClose: () => void;
  messageBody: string;
}

export function BcSaveTemplateModal({ onClose, messageBody }: Props) {
  const qc = useQueryClient();
  const [name, setName] = useState('');

  useEffect(() => {
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const save = useMutation({
    mutationFn: async () => api.post('/broadcasts/templates', { name: name.trim(), message: messageBody }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['broadcast-templates'] });
      toast.success('Template saved', name);
      onClose();
    },
    onError: () => toast.error('Save failed'),
  });

  return createPortal(
    <div className="mo open" onClick={onClose}>
      <div className="modal" style={{ width: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-title">💾 Save as Template</div>
        <div className="modal-sub" style={{ marginBottom: 12 }}>This template will appear in the picker for future broadcasts.</div>
        <div className="form-row"><label className="form-label">Template name</label><input type="text" className="form-input" id="bc-tpl-name" placeholder="e.g. Weekly Check-in" value={name} onChange={(e) => setName(e.target.value)} /></div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={() => save.mutate()} disabled={save.isPending || !name.trim()}>{save.isPending ? 'Saving…' : 'Save Template'}</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
